import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  filters: { range: "all", from: null, to: null },
};

const proposalDashboardSlice = createSlice({
  name: "proposalDashboard",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
});

export const { setFilters } = proposalDashboardSlice.actions;

export default proposalDashboardSlice.reducer;
